import { LOCAL_BASE, LOCAL_PORT, LOCAL_SECURE, RELEASE } from '../env';
import { EndpointType, Stage, Theme } from '../types';
import { flushSupportChatApiUrl } from './flush';
export const localEndpointSettings = {
    name: 'Local service endpoint',
    endpointType: EndpointType.Local,
    theme: Theme.Flush,
    base: LOCAL_BASE,
    baseCurrency: 'USD',
    baseCurrencySymbol: '$',
    baseCurrencyDigits: 2,
    baseLocal: true,
    basePort: LOCAL_PORT,
    baseInsecure: !LOCAL_SECURE,
    realm: 'stage2-flush',
    reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
    supportChatApiUrl: flushSupportChatApiUrl
    // apiPlayerSubscriptionUrl: 'ws://127.0.0.1:8000/player',
    // apiPlayerUrl: 'http://127.0.0.1:8000/player',
    // apiPublicSubscriptionUrl: 'ws://127.0.0.1:8000/public',
    // apiPublicUrl: 'http://127.0.0.1:8000/public',
    // chatApiUrl: 'http://127.0.0.1:8000/chat/',
    // notifyApiUrl: 'http://127.0.0.1:8000/notifications'
};
export const devEndpointSettings = RELEASE !== Stage.Prod
    ? [
        {
            name: 'GameTech (Stage)',
            endpointType: EndpointType.Stage1,
            theme: Theme.Flush,
            betbyBrandId: '2440225334214402054',
            betbyEnabled: true,
            betbyScriptUrl: 'https://ui.invisiblesport.com/bt-renderer.min.js',
            base: 'monopoly-flush.net.infinitro.dev',
            baseCurrency: 'USD',
            baseCurrencySymbol: '$',
            baseCurrencyDigits: 2,
            realm: 'stage1-flush',
            reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
            supportChatApiUrl: flushSupportChatApiUrl,
            telegramAuthBot: 'PreviewEnvBot'
        },
        {
            name: 'GameTech (Stage)',
            endpointType: EndpointType.Stage1,
            theme: Theme.Fomo,
            betbyBrandId: '2511536227707133955',
            betbyEnabled: true,
            betbyScriptUrl: 'https://ui.invisiblesport.com/bt-renderer.min.js',
            base: 'monopoly-fomo.net.infinitro.dev',
            baseCurrency: 'USDT',
            baseCurrencyFiat: 'USD',
            baseCurrencySymbol: '$',
            baseCurrencyDigits: 2,
            realm: 'stage1-fomo',
            gamityBrandRef: 'fomo',
            gamityCurrency: 'USDT',
            gamityEnvironment: 'qa',
            reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
            optimoveTenantId: '1580',
            optimoveTenantToken: '695bf7e91a9840f4a535bbff918564ca'
        },
        {
            name: 'GameTech (Stage)',
            endpointType: EndpointType.Stage1,
            theme: Theme.Rocketbet,
            betbyBrandId: '2637696640701566984',
            betbyEnabled: true,
            betbyScriptUrl: 'https://ui.invisiblesport.com/bt-renderer.min.js',
            base: 'monopoly-rocket.net.infinitro.dev',
            baseCurrency: 'USD',
            baseCurrencySymbol: '$',
            baseCurrencyDigits: 2,
            realm: 'stage1-rocket',
            reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
        },
        {
            name: 'GameTech (Stage)',
            endpointType: EndpointType.Stage1,
            theme: Theme.Luna,
            base: 'monopoly-luna.net.infinitro.dev',
            baseCurrency: 'TRY',
            baseCurrencySymbol: '₺',
            baseCurrencyDigits: 2,
            realm: 'stage1-luna',
            reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
            optimoveTenantId: '1950',
            optimoveTenantToken: '144e2e7971da435b9bfbbcd943866483',
            // TODO: replace with the real tenant ref issued for this brand.
            sportmodity: {
                enabled: true,
                tenantRef: 'pam-demo-site',
                sdkBaseUrl: 'https://betting-dev.sportsmodity.com',
                embedUrl: '/embed'
            }
        },
        {
            name: 'GameTech (Stage)',
            betbyEnabled: true,
            betbyBrandId: '2710204197164425219',
            betbyScriptUrl: 'https://ui.invisiblesport.com/bt-renderer.min.js',
            endpointType: EndpointType.Stage1,
            theme: Theme.Turboslots,
            base: 'monopoly-turbo.net.infinitro.dev',
            baseCurrency: 'TRY',
            baseCurrencySymbol: '₺',
            baseCurrencyDigits: 2,
            realm: 'stage1-turbo',
            gamityBrandRef: 'turbobet',
            gamityCurrency: 'TRY',
            gamityEnvironment: 'qa',
            integrationRef: 'visionlink-gametech',
            reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
            optimoveTenantId: '1946',
            optimoveTenantToken: 'e85e6a8fceb740349579828c26e0917e',
            // TODO: replace with the real tenant ref issued for this brand.
            sportmodity: {
                enabled: true,
                tenantRef: 'pam-demo-site',
                sdkBaseUrl: 'https://betting-dev.sportsmodity.com',
                embedUrl: '/embed'
            }
        },
        localEndpointSettings
    ]
    : [];
